import { RsuiteColor } from '@@partner:types:app'
import { DELIVERY_CLAIM } from '@hive/status'

export const DELIVERY_CLAIM_TYPE_INHOUSE_EXPRESS = 'inhouseExpress'
export const DELIVERY_CLAIM_TYPE_INHOUSE = 'inhouse'
export const DELIVERY_CLAIM_TYPE_YANGO = 'yango'
export const DELIVERY_CLAIM_TYPE_YANGO_EXPRESS = 'yangoExpress'
export const DELIVERY_CLAIM_TYPE_PICKUP = 'pickup'
export const DELIVERY_CLAIM_TYPE_WOLT = 'wolt'
export const DELIVERY_CLAIM_TYPE_WOLT_EXPRESS = 'woltExpress'
export const DELIVERY_CLAIM_TYPE_CHOCO = 'choco'
export const DELIVERY_CLAIM_TYPE_CHOCO_EXPRESS = 'chocoExpress'


export const DELIVERY_CLAIM_TYPE_LABELS = [
  {
    type: DELIVERY_CLAIM_TYPE_INHOUSE_EXPRESS,
    label: 'Экспресс (свой курьер)'
  },
  {
    type: DELIVERY_CLAIM_TYPE_INHOUSE,
    label: 'Свой курьер'
  },
  {
    type: DELIVERY_CLAIM_TYPE_YANGO,
    label: 'Яндекс'
  },
  {
    type: DELIVERY_CLAIM_TYPE_YANGO_EXPRESS,
    label: 'Яндекс (экспресс)'
  },
  {
    type: DELIVERY_CLAIM_TYPE_PICKUP,
    label: 'Самовывоз'
  },
  {
    type: DELIVERY_CLAIM_TYPE_CHOCO,
    label: 'Choco'
  },
  {
    type: DELIVERY_CLAIM_TYPE_CHOCO_EXPRESS,
    label: 'Choco (экспресс)'
  },
  {
    type: DELIVERY_CLAIM_TYPE_WOLT,
    label: 'Wolt'
  },
  {
    type: DELIVERY_CLAIM_TYPE_WOLT_EXPRESS,
    label: 'Wolt (экспресс)'
  }
]


export const getDeliveryClaimTypeLabel = (type: string): string => {
  if (type === undefined) {
    return ''
  }

  return DELIVERY_CLAIM_TYPE_LABELS.find(typeClaim => typeClaim.type === type)?.label ?? 'Неизвестный способ доставки'
}



export function getDeliveryClaimStatusLabel (status: number): { label: string, color?: RsuiteColor } {
  switch (status) {
  case DELIVERY_CLAIM.INITIAL:
    return { label: 'Создана' }
  case DELIVERY_CLAIM.CONFIRMED:
    return { label: 'Подтверждена', color: 'blue' }
  case DELIVERY_CLAIM.SEARCH_PERFORMER:
    return { label: 'Поиск курьера', color: 'blue'}
  case DELIVERY_CLAIM.WAIT_ASSEMBLER:
    return { label: 'Ожидает вручения', color: 'blue'}
  case DELIVERY_CLAIM.WAIT_PERFORMER:
    return { label: 'Ожидает передачи', color: 'blue'}
  case DELIVERY_CLAIM.PICKEDUP:
    return { label: 'Курьер забрал заказ', color: 'blue'}
  case DELIVERY_CLAIM.IN_PROGRESS:
    return { label: 'Доставляется', color: 'blue'}
  case DELIVERY_CLAIM.ARRIVED:
    return { label: 'Подъезжает', color: 'blue'}
  case DELIVERY_CLAIM.FINISHED:
    return { label: 'Доставлен', color: 'green' }
  case DELIVERY_CLAIM.RETURNED:
    return { label: 'Возвращён', color: 'red'}
  case DELIVERY_CLAIM.EXTERNAL_REFUSED:
    return { label: 'Отменен сервисом', color: 'red'}
  case DELIVERY_CLAIM.CANCELED:
    return { label: 'Отменен', color: 'red'}
  default:
    return { label: `${'Незивестный статус'} ${status}`, color: 'red'}
  }
}